/*
 * @Author: your name
 * @Date: 2021-05-27 08:42:51
 * @LastEditTime: 2021-06-03 16:25:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \app-project\src\i18n\i18n.js
 */
import Vue from 'vue'
// import locale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
import en from './language/en'
import cn from './language/cn'
import th from './language/th'

Vue.use(VueI18n)

const messages = {
  en: en,
  cn: cn,
  th: th
}

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'cn', // 设置默认语言
  messages
})
/* 为了实现element插件的多语言切换 */
// locale.i18n((key, value) => i18n.t(key, value))

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js